import React from 'react';
import PropTypes from 'prop-types';

// MUI
import {Grid} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

// Components
import {BpCheckedIcon, BpIcon} from "components/WMS/AccordionShipment/checkboxIcons";

// Assets
import {blueColor, greyishBlue500} from "assets/jss/main";
import {FormattedMessage} from "react-intl";

AccordionShipmentItem.propTypes = {
    checked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    trackingNumber: PropTypes.string.isRequired,
    orderId: PropTypes.string.isRequired
};

function AccordionShipmentItem({checked, onClick, trackingNumber, orderId}) {
    return (
        <Grid
            onClick={onClick}
            container
            wrap={"nowrap"}
            alignItems={"center"}
            sx={{
                width: '100%',
                padding: '16px'
            }}
        >
            <Checkbox
                checked={checked}
                icon={<BpIcon/>}
                checkedIcon={<BpCheckedIcon/>}
                sx={{
                    marginRight: '16px',
                    color: blueColor,
                    '&.Mui-checked': {color: blueColor}
                }}
            />
            <Grid
                sx={{fontSize: '12px'}}
                container
                direction={"column"}
            >
                <span style={{fontWeight: 600}}>
                    <FormattedMessage id='wms.shipping.orderId' /> <span style={{color: blueColor}}>{orderId}</span>
                </span>
                <span style={{color: greyishBlue500}}>
                   <FormattedMessage id='wms.shipping.trackingNumber' /> {trackingNumber}
                </span>
            </Grid>
        </Grid>
    );
}

export default AccordionShipmentItem;
